export const API_TYPES = {
  shift: "shift",
  workplace: "workplace",
  worker: "worker",
  shiftLog: "shift-log",
} as const;
